import React, {useEffect, useState} from 'react';

function Window(props) {

    const [initialMousePosition, setInitialMousePosition] = useState(null);
    const [peekForward, setPeekForward] = useState(null);
    
     const handleMouseUp = () => {
         props.setLookOverMouseDown(false);
         setPeekForward(null);
         setInitialMousePosition(null);
     }

    const handleMouseMove = e => {
        const mousePosition = [e.nativeEvent.screenX, e.nativeEvent.screenY];
        if (initialMousePosition === null) {
            setInitialMousePosition(mousePosition)
        } else {
            if (props.direction === 'left' && !peekForward && mousePosition[0] - initialMousePosition[0] > 100) {
                setPeekForward(true);
            } else if (props.direction === 'left' && peekForward && mousePosition[0] - initialMousePosition[0] < 100) {
                setPeekForward(false);
            } else if (props.direction === 'right' && !peekForward && mousePosition[0] - initialMousePosition[0] < -100) {
                setPeekForward(true);
            } else if (props.direction === 'right' && peekForward && mousePosition[0] - initialMousePosition[0] > -100) {
                setPeekForward(false);
            }
        }
    }

    useEffect(() => {
        document.body.addEventListener( 'mouseleave', () => handleMouseUp())
        document.body.addEventListener( 'mouseup', () => handleMouseUp())

        return () => {
            document.body.removeEventListener( 'mouseleave', () => handleMouseUp())
            document.body.removeEventListener( 'mouseup', () => handleMouseUp())

        }
    },[])

    return (
        <div className={`Window ${props.direction} ${props.class}`} onMouseUp={handleMouseUp} onMouseMove={handleMouseMove} >
            <div className={`interior ${props.direction} `}>
                <button className={`look-forward button`} onClick={() => props.setView('default')} />
                <div className={`rock-and-roll ${peekForward === null ? '' : peekForward && props.direction === 'left' || peekForward === false && props.direction === 'right' ? 'right' : 'left'}`} />
                <div className={`cab`} />
            </div>
            <div className={`night-scrim`} />
            <div className={`exterior ${props.direction} ${peekForward ? 'peek' : ''} ${props.intersectionIndex > -1 ? 'intersection-'+props.intersectionIndex : ''}`}>
                {props.direction !== 'forward' && 
                    <>
                        <div className={`background ${props.direction === "left" ? props.leftSideView : props.direction === "right" ? props.rightSideView : ''}`}/>
                    </>
                }
            </div>
        </div>
    )
}

export default Window